import React from 'react'
import './Brochure.css'

export default function Brochure() {
  return (
    <div className='brochure_div'>
      <h2>Download Rulebook</h2>
      <h3>Details and Schedule of Aerophilia 2022</h3>
      <a href="https://drive.google.com/file/d/1INpgSfittqYd-56EverMVYRFGQ9P-PBo/view?usp=share_link" download ><button className='button-63'>Rulebook</button></a>
    </div>
  )
}
